module.exports = __webpack_public_path__ + "img/bg.58469c1c.jpg";